import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { fileToDataUrl } from "@/lib/image";
import { toast } from "sonner";

export function ImageUpload({ value, onChange, testId = "image-upload", label = "Upload Image" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      onChange(await fileToDataUrl(file));
      toast.success("Image ready");
    } catch {
      toast.error("Could not read image");
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div className="flex items-center gap-3">
      {value ? (
        <img src={value} alt="preview" className="h-14 w-14 rounded-lg border border-gray-200 object-cover" />
      ) : null}
      <button
        type="button"
        data-testid={testId}
        onClick={() => ref.current?.click()}
        className="inline-flex items-center gap-2 rounded-xl border border-gray-200 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
      >
        <Upload className="h-4 w-4" /> {busy ? "Processing..." : label}
      </button>
      <input ref={ref} type="file" accept="image/*" onChange={handle} className="hidden" />
    </div>
  );
}
